<template>
  <div class='settings'>
    <a-tabs v-model:activeKey="activeKey" tab-position='left' class='settingTabs'>
      <a-tab-pane key="1" :tab="t(`account.basicSetup`)">
        <UserInfo />
      </a-tab-pane>
      <a-tab-pane key="2" :tab="t(`account.changePassword`)">
        <ChangePw />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import UserInfo from '../components/userInfo/index.vue'
import ChangePw from '../components/changePw/index.vue'
import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()

const mode = ref<string>('let')
const activeKey = ref('1')
</script>

<style lang='less'>
@import url('./index.less');
</style>
